import { headers, logPrefix } from './constants';
import Identity from './identity';
import JSONResponseHandler from '../serviceHelpers/JSONResponseHandler';
import { APIErrorResponse, isAPIErrorResponse } from '../serviceHelpers/APIErrorResponse';

export interface UserSettings {
  disqus?: {
    ssoKey: string;
  };
}

/**
 * Gets a list of user specific settings. This includes things like the disqus SSO token.
 * Settings are user specific so a user must be authenticated to call this API.
 *
 * @returns
 * A __Promise__ which resolves to a JSON object with SSO token and public key for Disqus
 *
 * <details>
 * <summary>
 * On success (resolves)
 * </summary>
 *
 * ```json
 *
 * ```
 * </details>
 *
 * <details>
 * <summary>
 * On errors (throws)
 * </summary>
 *
 * ```
 * See documentation for corresponding error codes:
 * https://redirector.arcpublishing.com/alc/docs/swagger/?url=./arc-products/arc-identity-v1.json#/User_Settings/getSettings
 * ```
 * </details>
 **/
export async function getUserSettings(): Promise<UserSettings | APIErrorResponse> {
  if (!Identity.userSettings) {
    const isLoggedIn = await Identity.isLoggedIn();
    if (!isLoggedIn) {
      throw new Error(`${logPrefix} Missing or invalid jwt`);
    }

    return fetch(`${Identity.apiOrigin}/identity/public/v1/user/settings`, {
      method: 'GET',
      cache: 'no-cache',
      headers: {
        Authorization: `Bearer ${Identity.userIdentity.accessToken}`,
        ...headers
      }
    })
      .then(JSONResponseHandler)
      .then(json => {
        if (isAPIErrorResponse(json)) {
          throw json;
        } else {
          Identity.userSettings = json;
          return json;
        }
      });
  } else {
    return Identity.userSettings;
  }
}

export default getUserSettings;
